import { FC, HTMLAttributes } from 'react';

export const TableSortAscButton: FC<HTMLAttributes<HTMLSpanElement>> = ({
  ...rest
}) => {
  return (
    <div {...rest}>
      <i className={`ra-icons-generic-sort`}></i>
    </div>
  );
};

export const TableSortDescButton: FC<HTMLAttributes<HTMLSpanElement>> = ({
  ...rest
}) => {
  return (
    <div {...rest}>
      <i className={`ra-icons-generic-sort-descending`}></i>
    </div>
  );
};
